import api from './baseApi';

export const getContractsByUserId = (myportalUserId, params) =>
  api.get(`/contracts/client/${myportalUserId}`, params);
